var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.8571 0.692383H99V14.8352H84.8571V0.692383ZM84.8571 21.9067H99V36.0495H84.8571V21.9067ZM63.6428 0.692383H77.7857V14.8352H63.6428V0.692383ZM63.6428 21.9067H77.7857V36.0495H63.6428V21.9067Z",
    fill: "#5A4DC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9286 50.1922V71.4065H7.07143V14.8351H49.5V7.76367H7.07143C5.19597 7.76367 3.39732 8.50869 2.07117 9.83485C0.745023 11.161 0 12.9596 0 14.8351V71.4065C0 73.282 0.745023 75.0806 2.07117 76.4068C3.39732 77.7329 5.19597 78.478 7.07143 78.478H35.3571V92.6208H21.2143V99.6922H77.7857V92.6208H63.6429V78.478H91.9286C93.804 78.478 95.6027 77.7329 96.9288 76.4068C98.255 75.0806 99 73.282 99 71.4065V50.1922H91.9286ZM56.5714 92.6208H42.4286V78.478H56.5714V92.6208Z",
    fill: "#5A4DC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.ca9620d29cc3a93b03b2f5e8fe2292cc.svg";
export { ForwardRef as ReactComponent };